



































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {InputSelect} from '@simpli/vue-input'

@Component({
  components: {
    InputSelect,
  },
})
export default class FilterLeaderboardOrbit extends Vue {
  @Prop({type: Array, required: true}) periodOptions!: string[]
  @Prop({type: String, required: true}) selectedPeriod!: string

  handleSelectPeriod(option: string) {
    this.$emit('select-period', option)
  }
}
